import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@babackapp/ui/components/card";
import { useViewerHasAtLeastAdminRights } from "@/lib/rights/use-viewer-has-right";
import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import { Separator } from "@radix-ui/react-dropdown-menu";
import { PlusIcon } from "@radix-ui/react-icons";
import { useCarriersContext } from "../use-carriers-context";
import LocationListItem from "./components/location-list-item";
import { AddLocationDialog } from "./forms/add-location-dialog";

export default function LocationsList() {
  const { shop } = useCarriersContext();
  const t = useTranslation();
  const canAddLocation = useViewerHasAtLeastAdminRights();

  return (
    <Card className="flex-1 min-w-[500px]">
      <CardHeader>
        <CardTitle>{t("carrier.locations.title")}</CardTitle>
        <CardDescription>{t("carrier.locations.description")} </CardDescription>
      </CardHeader>
      <CardContent className="mt-4">
        <div className="flex flex-col gap-2 mb-4">
          {shop?.locations.map((location, index) => (
            <div key={index + "location"}>
              {index > 0 && <Separator className="my-1" />}
              <LocationListItem key={location.id} location={location} />
            </div>
          ))}
        </div>
        {canAddLocation && (
          <div className="flex justify-end">
            <AddLocationDialog>
              <Button size="sm" className="gap-2">
                {t("carrier.locations.add")} <PlusIcon />
              </Button>
            </AddLocationDialog>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
